import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_DASHBOARD = gql`
  query getLoyaltyDashboard {
    getLoyaltyDashboard {
      isAuth
      kpis { fansWithPoints totalPointsAwarded prizesWon prizesClaimed prizesOpen prizesNoCodes achievementsUnlocked codesTotal codesUsed codesRemaining lowStockPrizes generatedAt }
    }
  }
`;

const getLoyaltyDashboard = async () => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_DASHBOARD, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyDashboard Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyDashboard : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyDashboard Error: ${error}`);
    return null;
  }
};

export default getLoyaltyDashboard;
